/**
 * Kargo Poşeti Ölçü Öneri Aracı
 */

class KargoPosetCalculator {
  constructor() {
    this.form = document.getElementById('kargo-poset-form');
    if (!this.form) return;

    this.els = {
      type:       document.getElementById('kp-type'),
      w:          document.getElementById('kp-w'),
      l:          document.getElementById('kp-l'),
      h:          document.getElementById('kp-h'),
      calc:       document.getElementById('kp-calc'),
      reset:      document.getElementById('kp-reset'),
      resultWrap: document.getElementById('kp-result'),
      need:       document.getElementById('kp-need'),
      size:       document.getElementById('kp-size'),
      goBtn:      document.getElementById('kp-go'),
      note:       document.getElementById('kp-note'),
      colorWrap:  document.getElementById('kp-color-wrap'),
      color:      document.getElementById('kp-color'),
      alert:      document.getElementById('kp-alert')
    };

    this._altsEl = null;
    this.DB      = null;
    this.injectStyles();
    this.init();
  }

  /* ── SCHEMA ─────────────────────────────────────────────── */
  buildSchema() {
    return {
      order: [
        'cepsiz', 'cepli',
        'buzlu', 'siyah_seffaf',
        'balonlu',
        'kisis_cepsiz', 'kisis_cepli',
        'kisis_buzlu',  'kisis_siyah'
      ],
      types: {
        cepsiz: {
          label: 'Cepsiz Kargo Poşeti',
          hasColor: true,
          colors: [
            { key: 'gri',   label: 'Gri',          handle: 'cepsiz-gri-kargo-poseti' },
            { key: 'lila',  label: 'Lila - Pembe',  handle: 'cepsiz-lila-kargo-poseti' },
            { key: 'gulk',  label: 'Gül Kurusu',    handle: 'cepsiz-gul-kurusu-kargo-poseti' },
            { key: 'yesil', label: 'Yeşil',         handle: 'cepsiz-yesil-kargo-poseti' },
            { key: 'mavi',  label: 'Mavi',          handle: 'cepsiz-kargo-poseti-mavi' },
            { key: 'mor',   label: 'Mor',           handle: 'cepsiz-mor-kargo-poseti' },
            { key: 'bej',   label: 'Bej',           handle: 'cepsiz-bej-kargo-poseti' },
            { key: 'beyaz', label: 'Beyaz',         handle: 'cepsiz-beyaz-kargo-poseti' }
          ]
        },
        cepli: {
          label: 'Cepli Kargo Poşeti',
          hasColor: true,
          colors: [
            { key: 'gri',   label: 'Gri',          handle: 'cepli-gri-kargo-poseti' },
            { key: 'lila',  label: 'Lila - Pembe',  handle: 'cepli-lila-kargo-poseti' },
            { key: 'gulk',  label: 'Gül Kurusu',    handle: 'cepli-gul-kurusu-kargo-poseti' },
            { key: 'mavi',  label: 'Mavi',          handle: 'cepli-mavi-kargo-poseti' },
            { key: 'yesil', label: 'Yeşil',         handle: 'cepli-yesil-kargo-poseti' }
          ]
        },
        buzlu: {
          label: 'Buzlu Şeffaf Kargo Poşeti',
          hasColor: false,
          handle: 'buzlu-seffaf-kargo-poseti',
          fallbackTo: 'siyah_seffaf'
        },
        siyah_seffaf: {
          label: 'Siyah-Şeffaf Kargo Poşeti',
          hasColor: false,
          handle: 'siyah-seffaf-kargo-poseti'
        },
        balonlu: {
          label: 'Balonlu Kargo Poşeti',
          hasColor: false,
          handle: 'balonlu-kargo-poseti-siyah'
        },
        kisis_cepsiz: {
          label: 'Kişiselleştirilebilir Marka Baskılı Cepsiz',
          hasColor: false,
          handle: 'kisisellestirilebilir-marka-baskili-cepsiz-renkli-kargo-poseti'
        },
        kisis_cepli: {
          label: 'Kişiselleştirilebilir Marka Baskılı Cepli',
          hasColor: false,
          handle: 'kisisellestirilebilir-marka-baskili-cepli-renkli-kargo-poseti'
        },
        kisis_buzlu: {
          label: 'Kişiselleştirilebilir Buzlu Şeffaf Kargo Poşeti',
          hasColor: false,
          handle: 'kisisellestirilebilir-marka-baskili-buzlu-seffaf-kargo-poseti',
          fallbackTo: 'kisis_siyah'
        },
        kisis_siyah: {
          label: 'Kişiselleştirilebilir Siyah-Şeffaf Kargo Poşeti',
          hasColor: false,
          handle: 'kisisellestirilebilir-marka-baskili-siyah-seffaf-kargo-poseti'
        }
      }
    };
  }

  /* ── INIT ───────────────────────────────────────────────── */
  async init() {
    this.setLoading(true);
    const schema = this.buildSchema();
    this.DB = await this.loadDatabase(schema);
    this.setLoading(false);
    this.bindEvents();
    this.renderTypeOptions();
    this.refreshUI(true);
  }

  /* ── VERİTABANI ─────────────────────────────────────────── */
  async loadDatabase(schema) {
    const db = { types: {}, order: [] };

    await Promise.all(
      schema.order.map(async (typeKey) => {
        const typeDef = schema.types[typeKey];
        if (!typeDef) return;

        if (typeDef.hasColor) {
          const colorResults = await Promise.all(
            typeDef.colors.map(async (c) => {
              const result = await this.fetchProduct(c.handle);
              if (!result) return null;
              return { key: c.key, label: c.label, url: `/products/${c.handle}`, sizes: result.sizes };
            })
          );
          const validColors = colorResults.filter(Boolean);
          if (!validColors.length) return;
          db.types[typeKey] = {
            label: typeDef.label, hasColor: true,
            colors: validColors, fallbackTo: typeDef.fallbackTo || null
          };
        } else {
          const result = await this.fetchProduct(typeDef.handle);
          if (!result) return;
          db.types[typeKey] = {
            label: typeDef.label, hasColor: false,
            sizes: result.sizes, link: `/products/${typeDef.handle}`,
            fallbackTo: typeDef.fallbackTo || null
          };
        }
      })
    );

    db.order = schema.order.filter(k => db.types[k]);
    return db;
  }

  async fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      const data = await res.json();
      const sizes = new Set();
      (data.variants || []).forEach(v => {
        if (!v.available) return;
        const norm = this.normalizeSize(v.option1);
        if (norm) sizes.add(norm);
      });
      return { sizes };
    } catch {
      return null;
    }
  }

  normalizeSize(raw) {
    if (!raw) return null;
    const clean = String(raw).replace(/×/g, 'x').replace(/\s/g, '').toLowerCase();
    return /^\d+x\d+\+\d+$/.test(clean) ? clean : null;
  }

  // "25x30+5" → "25×30 +5", küçük boyut her zaman önce
  formatSize(raw) {
    const m = String(raw).match(/^(\d+)x(\d+)\+(\d+)$/i);
    if (!m) return raw;
    const a = parseInt(m[1], 10);
    const b = parseInt(m[2], 10);
    const k = parseInt(m[3], 10);
    const small = Math.min(a, b);
    const large = Math.max(a, b);
    return `${small}×${large} +${k}`;
  }

  /* ── EVENTS ─────────────────────────────────────────────── */
  bindEvents() {
    this.els.type?.addEventListener('change', () => this.refreshUI(false));
    this.els.color?.addEventListener('change', () => this.clearMessages());

    this.els.calc?.addEventListener('click', (e) => {
      e.preventDefault();
      this.calculate();
    });

    this.form.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this.calculate(); }
    });

    this.els.reset?.addEventListener('click', (e) => {
      e.preventDefault();
      this.resetForm();
    });

    window.addEventListener('pageshow', () => this.refreshUI(true));
  }

  /* ── UI RENDERING ───────────────────────────────────────── */
  renderTypeOptions() {
    const sel = this.els.type;
    if (!sel) return;
    sel.innerHTML = '';
    this.DB.order.forEach(key => {
      const t = this.DB.types[key];
      if (!t) return;
      const opt = document.createElement('option');
      opt.value = key;
      opt.textContent = t.label;
      sel.appendChild(opt);
    });
    if (this.DB.order.length) sel.value = this.DB.order[0];
  }

  refreshUI(isInit) {
    this.clearMessages();
    this.renderAlternatives([], null);
    const typeKey = this.els.type?.value;
    const type = this.DB?.types[typeKey];
    if (!type) return;

    if (type.hasColor) {
      this.els.colorWrap.style.display = 'block';
      this.renderColorOptions(typeKey, isInit);
    } else {
      this.els.colorWrap.style.display = 'none';
    }

    this.disableGoButton();
  }

  renderColorOptions(typeKey, isInit) {
    const type = this.DB.types[typeKey];
    const sel  = this.els.color;
    if (!type?.colors || !sel) return;

    const prev = sel.value;
    sel.innerHTML = '';

    type.colors.forEach(c => {
      const opt = document.createElement('option');
      opt.value = c.key;
      opt.textContent = c.label;
      sel.appendChild(opt);
    });

    sel.value = (prev && type.colors.some(c => c.key === prev))
      ? prev : (type.colors[0]?.key || '');

    if (isInit) this.els.colorWrap.style.display = 'block';
  }

  setLoading(on) {
    if (this.els.calc) this.els.calc.disabled = on;
    if (this.els.type) this.els.type.disabled = on;
    if (on && this.els.type) {
      this.els.type.innerHTML = '<option>Yükleniyor...</option>';
    }
  }

  /* ── HESAPLAMA ──────────────────────────────────────────── */
  calculate() {
    this.clearMessages();
    this.renderAlternatives([], null);

    const w = this.toNum(this.els.w?.value);
    const l = this.toNum(this.els.l?.value);
    const h = this.toNum(this.els.h?.value);

    if (!(w > 0 && l > 0 && h >= 0)) {
      this.showAlert('Lütfen en, boy ve yükseklik değerlerini doğru girin.', { tone: 'danger' });
      return;
    }

    const needA = { w: w + h, l: l + h };
    const needB = { w: l + h, l: w + h };

    // Küçük boyut her zaman önce
    const rawMin  = needA.w * needA.l <= needB.w * needB.l ? needA : needB;
    const dispW   = Math.min(rawMin.w, rawMin.l);
    const dispL   = Math.max(rawMin.w, rawMin.l);
    this.els.need.textContent = `${this.round(dispW)} × ${this.round(dispL)} cm`;

    const typeKey = this.els.type.value;
    const outcome = this.resolveRecommendation(typeKey, needA, needB);

    /* ── Seçili renkte hiç uygun ölçü yok ── */
    if (outcome?.noFit) {
      this.els.size.textContent = 'Stokta uygun ölçü yok';
      this.disableGoButton();

      if (outcome.alternatives?.length) {
        this.showAlert('Seçtiğiniz renkte stokta uygun ölçü bulunmuyor.', { tone: 'danger' });
        this.renderAlternatives(outcome.alternatives, outcome.idealSize, 'Uygun ölçü bulunan renkler:');
      } else {
        this.showAlert('Bu ölçüde hiçbir renkte stokta uygun poşet bulunamadı.', { tone: 'danger' });
      }

      this.showResult();
      return;
    }

    /* ── Hiçbir şekilde sonuç yok ── */
    if (!outcome) {
      this.els.size.textContent = 'Listede uygun ölçü yok';
      this.disableGoButton();
      this.showAlert('Bu ölçüde uygun poşet bulunamadı.', { tone: 'danger' });
      this.showResult();
      return;
    }

    /* ── Sonuç var ── */
    this.els.size.textContent = this.formatSize(outcome.size);

    if (outcome.isOversize && outcome.alternatives?.length) {
      // Sıra: uyarı → Ürüne Git (ikincil) → alternatifler
      this.showAlert(
        `Seçtiğiniz renkte ${this.formatSize(outcome.idealSize)} mevcut değildir. ` +
        `Bu renkte uygun en küçük mevcut ölçü ${this.formatSize(outcome.size)}'dir. ` +
        `Yine de bu renkte devam etmek isterseniz:`,
        { tone: 'info' }
      );
      this.setGoButton(outcome.url, true);
      this.renderAlternatives(
        outcome.alternatives,
        outcome.idealSize,
        `Tam ölçü (${this.formatSize(outcome.idealSize)}) bulunan renkler:`
      );
    } else {
      this.setGoButton(outcome.url, false);
      if (outcome.message) {
        this.showAlert(outcome.message, { tone: 'amber', pulse: true });
      }
    }

    this.showResult();
  }

  /* ── ÖNERİ MANTIĞI ──────────────────────────────────────── */
  resolveRecommendation(typeKey, needA, needB) {
    const type = this.DB.types[typeKey];
    if (!type) return null;

    if (type.hasColor) {
      const chosenKey = this.els.color?.value;
      const chosen    = type.colors.find(c => c.key === chosenKey) || type.colors[0];
      if (!chosen) return null;

      const chosenSize  = this.smallestFromSet(chosen.sizes, needA, needB);
      const idealResult = this.findSmallestAcrossColors(type.colors, needA, needB);

      if (chosenSize) {
        const chosenArea = this.parseSize(chosenSize).area;
        const idealArea  = idealResult ? this.parseSize(idealResult.size).area : chosenArea;

        if (idealResult && chosenArea > idealArea) {
          const alts = this.getColorsWithSize(type.colors, idealResult.size, chosenKey);
          return {
            size: chosenSize, url: chosen.url,
            isOversize: true,
            idealSize: idealResult.size,
            alternatives: alts,
            message: ''
          };
        }

        return { size: chosenSize, url: chosen.url, message: '', alternatives: [] };
      }

      const alts = idealResult
        ? this.getColorsWithSize(type.colors, idealResult.size, chosenKey)
        : [];

      return { noFit: true, idealSize: idealResult?.size || null, alternatives: alts };
    }

    const direct = this.smallestFromSet(type.sizes, needA, needB);
    if (direct) return { size: direct, url: type.link, message: '', alternatives: [] };

    if (type.fallbackTo) {
      const fb = this.DB.types[type.fallbackTo];
      if (fb?.sizes) {
        const fbSize = this.smallestFromSet(fb.sizes, needA, needB);
        if (fbSize) {
          return {
            size: fbSize, url: fb.link,
            message: `"${type.label}" türünde bu ölçü bulunmuyor. "${fb.label}" ürününe yönlendiriyoruz.`,
            alternatives: []
          };
        }
      }
    }

    return null;
  }

  /* ── ÖLÇÜ YARDIMCILARI ──────────────────────────────────── */
  smallestFromSet(sizeSet, needA, needB) {
    if (!sizeSet?.size) return null;
    const sizes = Array.from(sizeSet)
      .map(s => this.parseSize(s))
      .filter(s => s.w > 0)
      .sort((a, b) => a.area - b.area);

    for (const s of sizes) {
      if (s.w >= needA.w && s.l >= needA.l) return s.raw;
      if (s.w >= needB.w && s.l >= needB.l) return s.raw;
    }
    return null;
  }

  findSmallestAcrossColors(colors, needA, needB) {
    return colors.reduce((best, c) => {
      const size = this.smallestFromSet(c.sizes, needA, needB);
      if (!size) return best;
      const p = this.parseSize(size);
      if (!best || p.area < best.area) {
        return { area: p.area, size, url: c.url, colorLabel: c.label };
      }
      return best;
    }, null);
  }

  getColorsWithSize(colors, targetSize, excludeKey) {
    return colors
      .filter(c => c.key !== excludeKey && c.sizes.has(targetSize))
      .map(c => ({ label: c.label, url: c.url }));
  }

  parseSize(raw) {
    const m = String(raw).match(/^(\d+)\s*x\s*(\d+)\s*\+\s*(\d+)$/i);
    if (!m) return { raw, w: 0, l: 0, k: 0, area: Number.MAX_SAFE_INTEGER };
    const w = parseInt(m[1], 10);
    const l = parseInt(m[2], 10);
    const k = parseInt(m[3], 10);
    return { raw, w, l, k, area: w * l };
  }

  /* ── ALTERNATİF RENKLER ─────────────────────────────────── */
  renderAlternatives(alts, idealSize, title) {
    if (!this._altsEl) {
      this._altsEl = document.createElement('div');
      this._altsEl.className = 'kp-alts';
      const card    = document.querySelector('.kp-result__card');
      const actions = card?.querySelector('.kp-result__actions');
      // Ürüne Git butonunun ALTINA ekle
      if (card && actions) {
        card.insertBefore(this._altsEl, actions.nextSibling);
      } else if (card) {
        const noteDiv = card.querySelector('.rte');
        card.insertBefore(this._altsEl, noteDiv || null);
      }
    }

    if (!alts?.length) {
      this._altsEl.style.display = 'none';
      this._altsEl.innerHTML = '';
      return;
    }

    const heading = title || 'Uygun ölçü bulunan renkler:';
    this._altsEl.style.display = 'block';
    this._altsEl.innerHTML = `
      <div class="kp-alts__title">${heading}</div>
      <div class="kp-alts__list">
        ${alts.map(a => `<a href="${a.url}" class="kp-alts__btn">${a.label}</a>`).join('')}
      </div>
      <div class="kp-alts__note">Renklere tıkladığınızda ilgili ürün sayfasına yönlendirilirsiniz.</div>
    `;
  }

  /* ── CSS INJECT ─────────────────────────────────────────── */
  injectStyles() {
    if (document.getElementById('kp-alts-style')) return;
    const s = document.createElement('style');
    s.id = 'kp-alts-style';
    s.textContent = `
      .kp-alts {
        margin-top: 1.2rem;
        padding: 1.2rem 1.4rem;
        border-radius: 12px;
        background: #f0f6ff;
        border: 1px solid rgba(0, 80, 200, .12);
      }
      .kp-alts__title {
        font-size: 13.5px;
        font-weight: 600;
        margin-bottom: .75rem;
        color: #1a1a1a;
      }
      .kp-alts__list {
        display: flex;
        flex-wrap: wrap;
        gap: .5rem;
      }
      .kp-alts__btn {
        padding: .45rem 1rem;
        border-radius: 999px;
        background: #fff;
        border: 1px solid rgba(0,0,0,.15);
        font-size: 13px;
        font-weight: 600;
        text-decoration: none;
        color: #000;
        transition: background .15s, border-color .15s;
      }
      .kp-alts__btn:hover {
        background: #ddeeff;
        border-color: rgba(0,80,200,.3);
      }
      .kp-alts__note {
        margin-top: .75rem;
        font-size: 12px;
        opacity: .6;
      }
      .kp-go-btn--secondary {
        background: #fff !important;
        color: #000 !important;
        border: 1px solid rgba(0,0,0,.22) !important;
        box-shadow: none !important;
      }
      .kp-go-btn--secondary:hover {
        background: rgba(0,0,0,.04) !important;
      }
    `;
    document.head.appendChild(s);
  }

  /* ── UI YARDIMCILARI ────────────────────────────────────── */
  showResult() {
    this.els.resultWrap.style.display = 'block';
    this.els.resultWrap.classList.add('show');
    setTimeout(() => {
      this.els.resultWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 80);
  }

  hideResult() {
    this.els.resultWrap.style.display = 'none';
    this.els.resultWrap.classList.remove('show');
  }

  setGoButton(url, secondary = false) {
    this.els.goBtn.href = url;
    this.els.goBtn.setAttribute('aria-disabled', 'false');
    this.els.goBtn.classList.remove('is-disabled');
    this.els.goBtn.classList.toggle('kp-go-btn--secondary', secondary);
  }

  disableGoButton() {
    this.els.goBtn.href = 'javascript:void(0)';
    this.els.goBtn.setAttribute('aria-disabled', 'true');
    this.els.goBtn.classList.add('is-disabled');
    this.els.goBtn.classList.remove('kp-go-btn--secondary');
  }

  showAlert(text, opts = {}) {
    const tone  = opts.tone  || 'amber';
    const pulse = opts.pulse || false;

    if (opts.html) {
      this.els.alert.innerHTML = text;
    } else {
      this.els.alert.textContent = text;
    }

    this.els.alert.style.display = 'block';
    this.els.alert.classList.remove('kp-alert--amber', 'kp-alert--danger', 'kp-alert--info', 'kp-alert--pulse');
    this.els.alert.classList.add(
      tone === 'danger' ? 'kp-alert--danger' :
      tone === 'info'   ? 'kp-alert--info'   : 'kp-alert--amber'
    );
    if (pulse) this.els.alert.classList.add('kp-alert--pulse');
  }

  clearMessages() {
    this.els.alert.style.display = 'none';
    this.els.alert.textContent = '';
    this.els.alert.classList.remove('kp-alert--amber', 'kp-alert--danger', 'kp-alert--info', 'kp-alert--pulse');
  }

  resetForm() {
    this.els.w.value = '';
    this.els.l.value = '';
    this.els.h.value = '';
    this.hideResult();
    this.clearMessages();
    this.renderAlternatives([], null);
    this.disableGoButton();
    this.els.w.focus();
  }

  /* ── UTILS ──────────────────────────────────────────────── */
  toNum(v) {
    const n = parseFloat(String(v || '').replace(',', '.'));
    return Number.isFinite(n) ? n : 0;
  }

  round(n) {
    return Math.round(n * 10) / 10;
  }
}

document.addEventListener('DOMContentLoaded', () => new KargoPosetCalculator());
document.addEventListener('shopify:section:load', () => new KargoPosetCalculator());